module.exports = __webpack_public_path__ + "img/hotel3_min.901ce670.png";